import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { supabase } from '../lib/supabase';

export function useSuperAdmin() {
  const { user, loading: authLoading } = useAuth();
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkSuperAdminStatus = async () => {
      console.log('🔍 Super Admin Check - Starting...');
      console.log('🔍 User object:', user);
      console.log('🔍 Auth loading:', authLoading);
      console.log('🔍 Supabase client:', !!supabase);

      if (!user || !supabase) {
        console.log('❌ No user or supabase client available');
        setIsSuperAdmin(false);
        setLoading(false);
        return;
      }

      try {
        console.log('🔍 User email:', user.email);
        console.log('🔍 User metadata:', user.user_metadata);
        console.log('🔍 User app metadata:', user.app_metadata);

        // First check: user metadata (fastest)
        if (user.user_metadata?.is_super_admin === true) {
          console.log('✅ Super admin detected from user metadata');
          setIsSuperAdmin(true);
          setLoading(false);
          return;
        }

        // Second check: email match (immediate fallback)
        const isSuperAdminEmail = user.email === 'info@xdetailstudio.ca';
        console.log('🔍 Email match check:', user.email, '===', 'info@xdetailstudio.ca', '→', isSuperAdminEmail);

        if (isSuperAdminEmail) {
          console.log('✅ Super admin detected by email match');
          setIsSuperAdmin(true);
          setLoading(false);
          return;
        }

        // Third check: call the RPC function
        console.log('🔍 Calling is_super_admin RPC function...');
        const { data, error } = await supabase.rpc('is_super_admin');

        console.log('🔍 RPC Result - Data:', data, 'Error:', error);

        if (error) {
          console.warn('⚠️ Error checking super admin status via RPC:', error);
          // Use email fallback
          console.log('🔄 Using email fallback:', isSuperAdminEmail);
          setIsSuperAdmin(isSuperAdminEmail);
        } else {
          const isAdmin = data === true;
          console.log('🔍 RPC result processed:', data, '→', isAdmin);
          setIsSuperAdmin(isAdmin);
        }
      } catch (error) {
        console.error('❌ Exception in super admin check:', error);
        // Final fallback: check if email matches the super admin email
        const isSuperAdminEmail = user.email === 'info@xdetailstudio.ca';
        console.log('🔄 Exception fallback - email check:', isSuperAdminEmail);
        setIsSuperAdmin(isSuperAdminEmail);
      } finally {
        console.log('🏁 Super admin check complete');
        setLoading(false);
      }
    };

    if (authLoading) {
      console.log('⏳ Waiting for auth to finish loading...');
      return; // Wait for auth to finish loading
    }

    checkSuperAdminStatus();
  }, [user, authLoading]);

  // Log final state
  useEffect(() => {
    console.log('🎯 Final Super Admin State - isSuperAdmin:', isSuperAdmin, 'loading:', loading);
  }, [isSuperAdmin, loading]);

  return {
    isSuperAdmin,
    loading: loading || authLoading,
    user
  };
} 